import React from "react";

function WelcomeSection() {
  return (
    <section className="page-header">
      <div className="bg-shape grey"></div>
      <div className="container">
        <div className="page-header-content">
          <h2>Welcome To JhatkaByte</h2>
        </div>
      </div>
    </section>
  );
}

export default WelcomeSection;
